import React, { useContext } from 'react';
import AsButton from '../AsButton';
import Flex from '../containers/Flex';
import IconClose from '../svg/IconClose';
import ScrollableArea from '../scrollbar/ScrollableArea';
import ScrollbarSvg from '../scrollbar/ScrollbarSvg';
import { AsDropdownContext } from './AsDropdownContext';

const AsDropdownTongue = ({
    children,
    expanded = false,
    onApply,
    onClose,
    style,
    boundingRef,
    ...props
}) => {
    const {
        height,
        gutterOffset,
        gutterRef,
        maxVisibleHeight,
        scrollableAreaRef,
        scrollableHeight,
        scrollPx,
        setScrollPx
    } = useContext(AsDropdownContext);

    return expanded ? (
        <Flex
            {...props}
            style={{
                backgroundColor: '#ffffff',
                border: '1px solid #cccccc',
                borderRadius: '0 0 15px 15px',
                boxShadow: '3px 2px 11px 0 rgba(0,0,0,0.33)',
                flexDirection: 'column',
                position: 'absolute',
                padding: '16px 0 10px 0',
                width: (boundingRef?.current?.offsetWidth || 50) - 2,
                marginTop: -15,
                zIndex: 10,
                ...style
            }}
        >
            <Flex style={{ width: '100%', justifyContent: 'flex-end' }}>
                <div
                    id='as-dropdown-tongue-close-icon-hitbox'
                    style={{ cursor: 'pointer', padding: '0 9px' }}
                    onClick={onClose}
                >
                    <IconClose
                        height={18}
                        width={18}
                        viewBox='0 0 50 50'
                        id='as-dropdown-tongue-close-icon'
                    />
                </div>
            </Flex>

            <ScrollableArea
                id='as-dropdown-scrollable-area'
                ref={scrollableAreaRef}
                scrollPx={scrollPx}
                onScroll={setScrollPx}
                height={height}
                width='100%'
                scrollableLength={scrollableHeight}
                style={{
                    border:
                        typeof onApply === 'function'
                            ? '1px solid #cccccc'
                            : undefined,
                    borderLeft: 0,
                    borderRight: 0
                }}
            >
                <Flex spaceBetween style={{ width: '100%' }}>
                    <div
                        id='as-dropdown-content'
                        style={{
                            position: 'relative',
                            bottom: scrollPx,
                            width: '100%'
                        }}
                    >
                        {children}
                    </div>

                    {height !== 'max-content' && height !== '100%' && (
                        <div
                            ref={gutterRef}
                            style={{
                                border:
                                    typeof onApply === 'function' ||
                                    (height !== 'max-content' &&
                                        height !== '100%')
                                        ? '1px solid #cccccc'
                                        : undefined,
                                borderWidth:
                                    height !== 'max-content' &&
                                    height !== '100%'
                                        ? 1
                                        : '0 1px',
                                boxSizing: 'border-box',
                                height: height
                            }}
                        >
                            <ScrollbarSvg
                                scrollPx={scrollPx}
                                onScroll={setScrollPx}
                                gutterOffset={gutterOffset}
                                maxVisibleLength={maxVisibleHeight}
                                scrollableLength={scrollableHeight}
                            />
                        </div>
                    )}
                </Flex>
            </ScrollableArea>
            {typeof onApply === 'function' && (
                <Flex centre style={{ paddingTop: 10 }}>
                    <AsButton
                        handleClick={onApply}
                        style={{
                            width: 96,
                            height: 34,
                            fontSize: 15,
                            fontWeight: 'bold'
                        }}
                    >
                        Apply
                    </AsButton>
                </Flex>
            )}
        </Flex>
    ) : null;
};

AsDropdownTongue.displayName = 'AsDropdownTongue';

AsDropdownTongue.defaultProps = {
    expanded: false
};

export default AsDropdownTongue;
